import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = {
  key: 0,
  class: "pi pi-exclamation-triangle kn-cursor-pointer"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_RegistryDatatableEditableField = _resolveComponent("RegistryDatatableEditableField")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_RegistryDatatableWarningDialog = _resolveComponent("RegistryDatatableWarningDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          class: "p-datatable-sm kn-table",
          scrollable: true,
          first: _ctx.first,
          "onUpdate:first": _cache[2] || (_cache[2] = ($event: any) => (_ctx.first = $event)),
          value: _ctx.rows,
          dataKey: "id",
          paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
          lazy: _ctx.lazyParams.size > _ctx.registryDescriptor.paginationLimit,
          paginator: true,
          rows: _ctx.registryDescriptor.paginationNumberOfItems,
          currentPageReportTemplate: 
            _ctx.$t('common.table.footer.paginated', {
                first: '{first}',
                last: '{last}',
                totalRecords: '{totalRecords}'
            })
        ,
          totalRecords: _ctx.lazyParams.size,
          stripedRows: "",
          showGridlines: "",
          sortMode: "multiple",
          multiSortMeta: _ctx.multiSortMeta,
          onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPage($event))),
          onSort: _ctx.onSort
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              class: "kn-truncated",
              style: _ctx.registryDatatableDescriptor.numerationColumn.style,
              headerStyle: _ctx.registryDatatableDescriptor.numerationColumn.style,
              field: _ctx.columns[0].field,
              header: _ctx.columns[0].title
            }, null, 8, ["style", "headerStyle", "field", "header"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns.slice(1), (col) => {
              return (_openBlock(), _createBlock(_component_Column, {
                key: col.field,
                class: "kn-truncated",
                field: col.field,
                style: `min-width:${col.size}px; padding:0;`,
                sortable: col.columnInfo?.type !== 'timestamp' && col.columnInfo?.type !== 'date'
              }, {
                header: _withCtx(() => [
                  _createVNode("div", _hoisted_1, [
                    (_ctx.showDefaultNumberFormatIcon(col))
                      ? _withDirectives((_openBlock(), _createBlock("i", _hoisted_2, null, 512)), [
                          [
                            _directive_tooltip,
                            _ctx.$t('documentExecution.registry.numberFormatNotSupported'),
                            void 0,
                            { top: true }
                          ]
                        ])
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(col.title) + " ", 1),
                    (col.isEditable && col.columnInfo?.type !== 'boolean')
                      ? _withDirectives((_openBlock(), _createBlock("i", {
                          key: 1,
                          class: "pi pi-pencil edit-icon p-ml-2",
                          "data-test": col.field + '-icon'
                        }, null, 8, ["data-test"])), [
                          [
                            _directive_tooltip,
                            _ctx.$t('documentExecution.registry.isEditableField'),
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                body: _withCtx((slotProps) => [
                  _createVNode("div", {
                    class: "p-d-flex p-flex-row editableField",
                    style: `background-color:${col.color ?? 'none'}; opacity:${col.isEditable ? 1 : 0.7}`,
                    "data-test": col.field + '-body'
                  }, [
                    (col.editorType == 'TEXT' && col.columnInfo?.type === 'boolean')
                      ? (_openBlock(), _createBlock(_component_Checkbox, {
                          key: 0,
                          modelValue: slotProps.data[slotProps.column.props.field],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                          binary: true,
                          onChange: ($event: any) => (_ctx.setRowEdited(slotProps.data)),
                          disabled: !col.isEditable
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"]))
                      : (col.isEditable || col.columnInfo?.type === 'int' || col.columnInfo?.type === 'float')
                        ? (_openBlock(), _createBlock(_component_RegistryDatatableEditableField, {
                            key: 1,
                            column: col,
                            propRow: slotProps.data,
                            comboColumnOptions: _ctx.comboColumnOptions,
                            onRowChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setRowEdited($event))),
                            onDropdownChanged: _ctx.onDropdownChange,
                            onDropdownOpened: _ctx.addColumnOptions
                          }, null, 8, ["column", "propRow", "comboColumnOptions", "onDropdownChanged", "onDropdownOpened"]))
                        : (!col.isEditable)
                          ? (_openBlock(), _createBlock("span", _hoisted_3, [
                              (slotProps.data[col.field] && col.columnInfo?.type === 'date')
                                ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.getFormattedDate(slotProps.data[col.field], 'yyyy-MM-dd', _ctx.getCurrentLocaleDefaultDateFormat(col))), 1))
                                : (slotProps.data[col.field] && col.columnInfo?.type === 'timestamp')
                                  ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.getFormattedDateTime(slotProps.data[col.field], { dateStyle: 'short', timeStyle: 'medium' }, true)), 1))
                                  : (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(slotProps.data[col.field]), 1))
                            ]))
                          : _createCommentVNode("", true)
                  ], 12, ["data-test"])
                ]),
                _: 2
              }, 1032, ["field", "style", "sortable"]))
            }), 128)),
            _createVNode(_component_Column, {
              style: _ctx.registryDatatableDescriptor.iconColumn.style,
              headerStyle: _ctx.registryDatatableDescriptor.iconColumn.style
            }, {
              header: _withCtx(() => [
                (_ctx.buttons.enableButtons || _ctx.buttons.enableAddRecords)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "kn-button",
                      label: _ctx.$t('managers.businessModelManager.add'),
                      onClick: _ctx.addNewRow,
                      "data-test": "new-row-button"
                    }, null, 8, ["label", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              body: _withCtx((slotProps) => [
                (_ctx.buttons.enableButtons || _ctx.buttons.enableDeleteRecords)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-link",
                      onClick: ($event: any) => (_ctx.rowDeleteConfirm(slotProps.index, slotProps.data))
                    }, {
                      default: _withCtx(() => [
                        _createVNode("i", {
                          class: ["pi pi-flag", [slotProps.data.edited ? _ctx.flagShown : _ctx.flagHidden]],
                          style: _ctx.registryDatatableDescriptor.primevueTableStyles.trashNormal
                        }, null, 6),
                        _createVNode("i", {
                          class: "p-button-link pi pi-trash p-ml-2",
                          style: _ctx.registryDatatableDescriptor.primevueTableStyles.trashNormal
                        }, null, 4)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["style", "headerStyle"])
          ]),
          _: 1
        }, 8, ["first", "value", "lazy", "rows", "currentPageReportTemplate", "totalRecords", "multiSortMeta", "onSort"]))
      : _createCommentVNode("", true),
    _createVNode(_component_RegistryDatatableWarningDialog, {
      visible: _ctx.warningVisible,
      columns: _ctx.dependentColumns,
      onClose: _ctx.onWarningDialogClose
    }, null, 8, ["visible", "columns", "onClose"])
  ], 64))
}